import axios from "../axiosConfig.js";
// import { DEFAULT_API_URL } from "../config";
import API_URL from "../../../utils/apiUrl.js";
import {
    CONTACT_US_SUCCESS,
    CONTACT_US_FAILED,
    CONTACT_US_LOADING,
} from "./types";
import { createMessage } from "../messages";
// import { headerHelper } from "../auth/auth";
import errorHandler from "../errorHandler";

//   <--------------------------- CONTACT_US --------------------------->   //
export const contactUs = (name, email, message) => (dispatch, getState) => {
    //
    const data = {
        name: name,
        email: email,
        message: message,
    };

    dispatch({ type: CONTACT_US_LOADING });

    axios
        .post(
            `${API_URL}/notifications/contact_us/`,
            data
            //  headerHelper(getState)
        )
        .then(() => {
            dispatch({
                type: CONTACT_US_SUCCESS,
                // payload: res.data,
            });
            dispatch(createMessage(`Thank you for contacting us!`));
        })
        .catch((err) => {
            errorHandler(dispatch, err, CONTACT_US_FAILED, "Contacting us");
        });
};
